import type { SKUSelectionCtaProps } from '@src/components/SKUSelectionCta/SKUSelectionCta.props'

export const SKUSelectionCtaDefaults: SKUSelectionCtaProps = {
  copy: 'Add to Cart',
  redirectUrl: '/cart',
  extraSkus: [{ sku: 'BBBODINT40' }],
}
